export function trackError(error) {
  console.error(error);

  if (global.trackJs) {
    global.trackJs.track(error);
  }
}
